import GLightbox from 'glightbox'; // @link https://github.com/biati-digital/glightbox

// eslint-disable-next-line no-unused-vars
const lightbox = GLightbox({
  zoomable: false
});

GLightbox({
  selector: '.inline-info',
  content: document.getElementById('inline-info')
}).open();

function initCalendarLightbox () {
  const calendarLightbox = GLightbox({
    selector: '.glightbox-calendar',
    width: 500,
    height: 'auto',
    draggable: false,
    zoomable: false,
    keyboardNavigation: false,
    touchFollowAxis: false,
    touchNavigation: false
  });

  calendarLightbox.on('slide_after_load', (data) => {
  // data is an object that contain the following
    const { slideNode } = data;
    if (window.htmx) {
    // eslint-disable-next-line no-undef
      htmx.process(slideNode);
    }
  });
}

if (document.querySelector('.glightbox-calendar')) {
  initCalendarLightbox();
}

if (window.htmx) {
  // eslint-disable-next-line no-undef
  htmx.onLoad(() => {
    initCalendarLightbox();
  });
}
